<div>
  <div class="row-no-margin section-header-container">
    <div class="col-md-10 clear-padding">
      <span class="section-header">News and Updates</span>
    </div>
    <div class="col-md-2 clear-padding">
      
        <button class="blue" (click)="AddNewsItem()" >Add New Item</button>
      
    </div>
  </div>
  <div class="row-no-margin" style="justify-content:center;">
    <div class="col-md-9">
      <div  cdkDropList (cdkDropListDropped)="NewsItemDropped($event)" class="col-md-12">
        <div cdkDrag [cdkDragData]="news" *ngFor="let news of NewsList" class="infoCenterTile row-no-margin">
          <div *cdkDragPreview>{{news.Title}}</div>
          <!--Filename-->
          <div class="col-md-4 clear-padding">
            <span style="font-size:15px;line-height:20px;">Updated {{news.UpdatedDate | date: 'short'}}</span>
            <br />
            <span style="font-size:17px; line-height:20px;font-weight:500;">{{news.Title}}</span>
          </div>
          <!--File Type/Category-->
          <div class="col-md-2 clear-padding" style="text-align:center;">
            <span class="clickable blue-color" (click)="GoToArticle(news)">Link To Article</span>
          </div>
          <div class="col-md-5 clear-padding" style="text-align:center;">
            <span style="font-size:15px;line-height:20px;font-weight:600;">{{news.Description}}</span>

          </div>
          <div class="col-md-1 clear-padding" style="text-align:center;">
            <span style="padding-right:10px;" title="Edit">
              <fa-icon [icon]="faPenToSquare" (click)="EditNewsItem(news)" class="fa-light fa-2x  clickable blue-color"></fa-icon>
            </span>
            <span>
              <fa-icon [icon]="faXmark" (click)="DeleteNewsItem(news)" class="fa-2x clickable blue-color"></fa-icon>
            </span>
          </div>
        </div>

        <mat-paginator [length]="ItemCount" [pageSize]="PageSize" [pageSizeOptions]="PageSizeOptions" (page)="PageEvent($event)">
        </mat-paginator>
      </div>
    </div>
  </div>
</div>
